export const DEFAULT_MAX_DISTANCE_ALLOWED_FOR_LOCATION_VERIFICATION_IN_MILES = 130;

export const GET_GEOLOCATION_TIMEOUT_IN_MILLISECONDS = 6000;

/**
 * Maximum age for cached GPS positions in the route estimate (TAT) flow (15 minutes).
 * Positions older than this will trigger a fresh GPS acquisition.
 * Prevents using arbitrarily stale cached coordinates that could be
 * hundreds of kilometers away from the worker's actual position.
 */
export const ROUTE_ESTIMATE_GEOLOCATION_MAXIMUM_AGE_IN_MILLISECONDS = 900_000;

/**
 * Extended timeout for GPS acquisition in the route estimate (TAT) flow (15 seconds).
 * Longer than the default 6s to accommodate GPS cold starts, which can take 20-45s
 * but are typically resolved within 15s for warm starts.
 */
export const ROUTE_ESTIMATE_GEOLOCATION_TIMEOUT_IN_MILLISECONDS = 15_000;

/**
 * Maximum acceptable GPS accuracy radius for the route estimate (TAT) flow (10 km).
 * Readings with accuracy worse than this (e.g., IP-based estimates)
 * are rejected to prevent computing inflated ETAs from imprecise coordinates.
 * Set to 10 km to accommodate single cell tower estimates in rural areas.
 */
export const ROUTE_ESTIMATE_GEOLOCATION_MAX_ACCURACY_IN_METERS = 10_000;

export const MIN_ANDROID_OS_WITH_ALWAYS_ALLOW_OPTION = "10.0.0";

export const MILES_TO_METERS_MULTIPLIER = 0.000_621_371_2;

export enum UrgentShiftLocalStorage {
  GENERAL_PRIMER_PAGE_VIEWED = "generalPrimerPageViewed",
  LAST_LOCATION_PERMISSION_STATUS = "lastLocationPermissionStatus",
  USER_DISABLED_FULL_LOCATION_PERMISSION = "userDisabledFullLocationPermission",
}

export enum LocationAccuracyStatus {
  FULL = "full",
  REDUCED = "reduced",
}

export enum TripTrackingTrigger {
  APP_OPEN = "appOpen",
  LOCATION_UPDATE = "locationUpdate",
  SILENT_PUSH_NOTIFICATION = "silentPushNotification",
  URGENT_SHIFT_BOOKING = "urgentShiftBooking",
}

export enum LocationTrackingMode {
  STOP = "stop",
  PASSIVE = "passive",
  AGGRESSIVE = "aggressive",
  ONSITE = "onsite",
}
